import { createContext, useContext } from 'react';

export const ManualAdjustmentContext = createContext();
export const useManualAdjustmentContext = () => useContext(ManualAdjustmentContext);
